import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/check/train/trainList/getTrainListDataPage",
    method: "get",
    params,
  });
};

export const getDetail = (params) => {
  return request({
    url: "/check/train/detailList/getTrainListDetailData",
    method: "get",
    params,
  });
};
// 进出线记录详情更新
export const updateDetail = (params) => {
  return request({
    url: "/check/train/detailList/update",
    method: "post",
    data: params,
  });
};

// 空箱进港
export const inLineGenOrderPlan = (id) => {
  return request({
    url: `/check/train/trainList/inLineGenOrderPlan?trainListId=${id}`,
    method: "post",
  });
};
